import React from 'react'
import IconWrapper from './styles'

interface ContactIconProps {
  disabled?: boolean
}

export const ContactIcon = (props: ContactIconProps) => {
  const { disabled } = props
  return (
    <IconWrapper disabled={disabled}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.7471 10.9312C11.4524 10.2331 11.0246 9.59891 10.4877 9.06406C9.95247 8.52767 9.31841 8.10001 8.62055 7.80469C8.6143 7.80156 8.60805 7.8 8.6018 7.79688C9.57524 7.09375 10.208 5.94844 10.208 4.65625C10.208 2.51562 8.47367 0.78125 6.33305 0.78125C4.19242 0.78125 2.45805 2.51562 2.45805 4.65625C2.45805 5.94844 3.09086 7.09375 4.0643 7.79844C4.05805 7.80156 4.0518 7.80312 4.04555 7.80625C3.34555 8.10156 2.71742 8.525 2.17836 9.06563C1.64197 9.60089 1.2143 10.235 0.918984 10.9328C0.628863 11.616 0.472394 12.3485 0.458047 13.0906C0.45763 13.1073 0.460555 13.1239 0.46665 13.1394C0.472745 13.1549 0.481886 13.1691 0.493535 13.181C0.505184 13.193 0.519105 13.2025 0.534478 13.2089C0.549851 13.2154 0.566365 13.2188 0.583047 13.2188H1.52055C1.5893 13.2188 1.64398 13.1641 1.64555 13.0969C1.6768 11.8906 2.16117 10.7609 3.01742 9.90469C3.90336 9.01875 5.07992 8.53125 6.33305 8.53125C7.58617 8.53125 8.76274 9.01875 9.64867 9.90469C10.5049 10.7609 10.9893 11.8906 11.0205 13.0969C11.0221 13.1656 11.0768 13.2188 11.1455 13.2188H12.083C12.0997 13.2188 12.1162 13.2154 12.1316 13.2089C12.147 13.2025 12.1609 13.193 12.1726 13.181C12.1842 13.1691 12.1934 13.1549 12.1994 13.1394C12.2055 13.1239 12.2085 13.1073 12.208 13.0906C12.1924 12.3437 12.0377 11.6172 11.7471 10.9312V10.9312ZM6.33305 7.34375C5.61586 7.34375 4.94086 7.06406 4.43305 6.55625C3.92523 6.04844 3.64555 5.37344 3.64555 4.65625C3.64555 3.93906 3.92523 3.26406 4.43305 2.75625C4.94086 2.24844 5.61586 1.96875 6.33305 1.96875C7.05024 1.96875 7.72523 2.24844 8.23305 2.75625C8.74086 3.26406 9.02055 3.93906 9.02055 4.65625C9.02055 5.37344 8.74086 6.04844 8.23305 6.55625C7.72523 7.06406 7.05024 7.34375 6.33305 7.34375Z"
          fill="black"
          fillOpacity="0.88"
        />
      </svg>
    </IconWrapper>
  )
}
